import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Modal, message, Card } from "antd";
import { Content } from "antd/es/layout/layout";
import TotalRewards from "../../Components/DashboardComponents/totalRewards";
import ReferralBanner from "../../Components/DashboardComponents/referralBanner";
import "./dashboard.scss";
import { Link, useOutletContext } from "react-router-dom";
import tdxMob from "../../assets/tdx banner/BAAI-TDX banner-mobile.webp";
import twitterDesktop from "../../assets/twitterSpace/Twitter-Space-banner-desktop.webp";
import twitterMob from "../../assets/twitterSpace/Twitter-Space-banner-mobile.webp";
import { Tweet } from "react-twitter-widgets";
import dashboardService from "../../services/dashboardService";
// import TransactionTable from '../../Components/DashboardComponents/transactionTable'
import LeaderBoard from "../../Components/DashboardComponents/leaderBoard";
import EmailOptIn from "./emailOptIn";
import { ThemeContext } from "../../context/themeProvider";
import AudioPlayer from "../../Components/DashboardComponents/audioPlayer/audioPlayer";
import { useSelector } from "react-redux";
import MyReferralsBanner from "../../Components/DashboardComponents/MyReferralsBanner";
import UserInstructions from "../UserInstructions/userinstructions";
import { store } from "../../Components/Redux/store";
import { setInstructionFalse } from "../../Components/Redux/actions";

const ROOT = `dashboard_product`;

const MyDashboard = (props) => {
  const outletProps = useOutletContext();
  const { colorBgContainer, cardBackgroundColor } = outletProps;
  const { setHeaderTitle, headerTitle } = props;
  const [tweets, setTweets] = useState("");
  const { setLoading } = useContext(ThemeContext);
  const promotion = useSelector((state) => state.promotion.isCompleted);
  const instruction = useSelector((state) => state.instruction.show);

  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle("My Dashboard");
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle("");
    };
  }, [setHeaderTitle]);

  useEffect(() => {
    getTweetDetails();
    // eagerLoadTwitterLibrary()
  }, []);

  const getTweetDetails = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getTweetsData();
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message || "Something went worng in getting tweets"
        );
      } else {
        setTweets(response?.data);
        console.log(response?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <Modal
        open={instruction}
        footer={null}
        onCancel={() => {
          store.dispatch(setInstructionFalse(false));
        }}
        closeIcon={false}
      >
        <UserInstructions />
      </Modal>

      <Content
        style={{
          minHeight: 280,
          paddingTop: 0,
          background: colorBgContainer,
        }}
        className={`${ROOT}__content_body`}
      >
        <Row>
          {/* <Form
          name="normal_login"
          layout="vertical"
          className="login-form"
          initialValues={{
            mobile: '',
            countryCode: '',
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: 'Please input your phone number!',
              },
            ]}
          >
            <Input
              // addonBefore={prefixSelector}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>

          <Form.Item className="mb-0">
            <Button
              block
              size="large"
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Log in
            </Button>
          </Form.Item>
        </Form> */}
        </Row>

        {promotion && (
          <Row
            gutter={[0, 20]}
            style={{ background: colorBgContainer }}
            className="banner_ui"
          >
            <Col lg={24} xs={24} sm={24}>
              <MyReferralsBanner />
            </Col>
          </Row>
        )}

        <Row
          gutter={[0, 20]}
          style={{ background: colorBgContainer }}
          className="banner_ui"
        >
          <Col lg={24} xs={24} sm={24}>
            <ReferralBanner headerTitle={headerTitle} />
          </Col>
        </Row>
        <div
          style={{
            position: "relative",
            padding: "0px 20px",
            backgroundColor: "#fff",
          }}
        >
          <Row gutter={[20, 20]} className="mb-4 mt-3">
            {tweets &&
              tweets?.map((tweet) => {
                return (
                  <Col lg={8} xs={24} key={tweet?._id}>
                    <Card
                      style={{ height: "340px", overflow: "auto" }}
                      className={`${ROOT}__twitter_box`}
                    >
                      <Tweet
                        tweetId={tweet?.tweetId}
                        options={{ cards: "hidden", conversation: "none" }}
                        // onLoad={() => <Spin tip="loading..." />}
                      />
                    </Card>
                  </Col>
                );
              })}
          </Row>
          <Row gutter={[20, 20]}>
            <Col lg={12} xs={24}>
              <TotalRewards
                cardBackgroundColor={cardBackgroundColor}
                page="my dashboard"
              />
            </Col>
            <Col lg={12} xs={24}>
              <LeaderBoard
                cardBackgroundColor={cardBackgroundColor}
                page="my dashboard"
              />
            </Col>
            {/* <Col lg={12} xs={24}>
              <TransactionTable
                cardBackgroundColor={cardBackgroundColor}
                page="my dashboard"
              />
            </Col> */}
            {/* <Col lg={24} xs={24}>
              <LeaderBoard
                cardBackgroundColor={cardBackgroundColor}
                page="my dashboard"
              />
            </Col> */}
          </Row>
          {/* email opt-in row component */}
          <EmailOptIn />
          {/* email opt-in row component */}
          <Row
            gutter={[0, 0]}
            style={{ background: colorBgContainer }}
            className=" px-0"
          >
            {/* <Col xl={24} lg={24} md={24} sm={0} xs={0}>
              <div className="py-3">
                <Link to="https://tdx.biz/baai_giveaway/" target="_blank">
                  <img width="100%" src={tdxDesktop} alt="" />
                </Link>
              </div>
            </Col> */}

            <Col xl={0} lg={0} md={0} sm={24} xs={24}>
              <div className="py-3">
                <Link to="https://tdx.biz/baai_giveaway/" target="_blank">
                  <img width="100%" src={tdxMob} alt="" />
                </Link>
              </div>
            </Col>
          </Row>
        </div>
        <Row
          gutter={[0, 0]}
          style={{ background: colorBgContainer }}
          className="banner_ui"
        >
          <Col xl={24} lg={24} md={24} sm={0} xs={0}>
            <div className="">
              {/* <Link
                to="https://twitter.com/i/spaces/1eaJbrWrRNZJX"
                target="_blank"
              > */}
              <img width="100%" src={twitterDesktop} alt="" />
              {/* </Link> */}
            </div>
          </Col>

          <Col xl={0} lg={0} md={0} sm={24} xs={24}>
            <div>
              {/* <Link
                to="https://twitter.com/i/spaces/1eaJbrWrRNZJX"
                target="_blank"
              > */}
              <img width="100%" src={twitterMob} alt="" />
              {/* </Link> */}
            </div>
          </Col>
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <AudioPlayer />
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default MyDashboard;
